import request from '@/utils/request'


// 查询印刷倍数列表
export function listPrintMultiples(query) {
  return request({
    url: '/user/print-multiples/list',
    method: 'get',
    params: query
  })
}

// 查询印刷倍数分页
export function pagePrintMultiples(query) {
  return request({
    url: '/user/print-multiples/page',
    method: 'get',
    params: query
  })
}

// 查询印刷倍数详细
export function getPrintMultiples(data) {
  return request({
    url: '/user/print-multiples/detail',
    method: 'get',
    params: data
  })
}

// 新增印刷倍数
export function addPrintMultiples(data) {
  return request({
    url: '/user/print-multiples/add',
    method: 'post',
    data: data
  })
}

// 修改印刷倍数
export function updatePrintMultiples(data) {
  return request({
    url: '/user/print-multiples/edit',
    method: 'post',
    data: data
  })
}

// 删除印刷倍数
export function delPrintMultiples(data) {
  return request({
    url: '/user/print-multiples/delete',
    method: 'post',
    data: data
  })
}

// 更新印刷倍数排序（仅更新 sort）
export function updatePrintMultiplesSort(data) {
  return request({
    url: '/user/print-multiples/update-sort',
    method: 'post',
    data: data
  })
}

// 更新印刷倍数状态（仅更新 status）
export function updatePrintMultiplesStatus(data) {
  return request({
    url: '/user/print-multiples/update-status',
    method: 'post',
    data: data
  })
}
